(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["detaied-description"] && !Shopify.designMode) return;
  try {
    
  function isMobile() {
    const { width } = window.screen;
    return width < 990;
  }
  function setupObserver(selector) {
    const items = Array.from(document.querySelectorAll(selector));
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = items.indexOf(entry.target);
            if (index !== -1) {
              setTimeout(() => {
                entry.target.classList.add('show');
              }, index * 240);
            }
          }
        });
      },
      { threshold: 0.1 }
    );

    items.forEach((item) => {
      observer.observe(item);
    });
  }

  function initializeObservers() {
    if (window.innerWidth < 990) {
      // console.log('Initializing observer for mobile view');
      setupObserver('.Designed__container,.Thoughtful__grid__box__mobile');
    } else {
      setupObserver('.Thoughtful__container');
    }
  }

  window.onload = function () {
    initializeObservers();
  };

  window.addEventListener('resize', function () {
    initializeObservers();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tenways-product-app"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
  function getScreenWidth() {
    return $(window).width();
  }

  function initDesktop() {
    const screenWidth = getScreenWidth();
    if (screenWidth <= 900) return;
    const desktopContainer = $('.app-features__content--desktop');
    if (desktopContainer.length === 0) return;

    const videoContainers = desktopContainer.find('.app-features__item-video-background');
    const videos = videoContainers.map(function () {
      return $(this).find('video')[0];
    }).get();
    
    let currentVideoIndex = 0;
    let hasStartedPlaying = false;
    let isInitialPlayComplete = false;

    function updateButtonState(activeIndex) {
      videos.forEach(function (_, index) {
        const playBtn = $(`#play-button-${index}`);
        const pauseBtn = $(`#pause-button-${index}`);
        if (playBtn.length && pauseBtn.length) {
          if (index === activeIndex) {
            playBtn.hide();
            pauseBtn.show();
          } else {
            playBtn.show();
            pauseBtn.hide();
          }
        }
      });
    }

    function handlePlayVideo(index) {
      if (videos[currentVideoIndex] && currentVideoIndex !== index) {
        videos[currentVideoIndex].pause();
      }
      currentVideoIndex = index;
      const video = videos[currentVideoIndex];
      if (!video) return;

      if (video.ended) {
        video.currentTime = 0;
      }

      video.play().catch(() => {});
      updateButtonState(currentVideoIndex);
      $(video).off('ended').on('ended', function () {
        updateButtonState(-1);
        if (!isInitialPlayComplete) {
          currentVideoIndex++;
          if (currentVideoIndex < videos.length) {
            playNextVideo();
          } else {
            isInitialPlayComplete = true;
            currentVideoIndex = 0;
          }
        }
      });
    }

    function playNextVideo() {
      const video = videos[currentVideoIndex];
      if (!video) return;
      video.currentTime = 0;
      video.play().catch(() => {});
      updateButtonState(currentVideoIndex);
      $(video).off('ended').on('ended', function () {
        updateButtonState(-1);
        if (!isInitialPlayComplete) {
          currentVideoIndex++;
          if (currentVideoIndex < videos.length) {
            playNextVideo();
          } else {
            isInitialPlayComplete = true;
            currentVideoIndex = 0;
          }
        }
      });
    }

    window.playVideo = handlePlayVideo;
    window.pauseVideo = function (index) {
      if (videos[index]) {
        videos[index].pause();
        updateButtonState(-1);
      }
    };

    function startObserver() {
      if (!('IntersectionObserver' in window)) {
        hasStartedPlaying = true;
        playNextVideo();
        return;
      }
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !hasStartedPlaying) {
              hasStartedPlaying = true;
              playNextVideo();
              observer.unobserve(desktopContainer[0]);
            }
          });
        },
        { threshold: 0.5 }
      );
      observer.observe(desktopContainer[0]);
    }

    startObserver();
  }

  function initMobile() {
    const screenWidth = getScreenWidth();
    if (screenWidth > 900) return;
    const mobileContainer = $('.app-features__content--mobile');
    if (mobileContainer.length === 0) return;

    const mobileSwiper = new Swiper('.swiper-container.app-features__content--mobile', {
      slidesPerView: 1.05,
      spaceBetween: 14,
      navigation: {
        nextEl: '.app-features-next.swiper-button-next',
        prevEl: '.app-features-prev.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination-progressbar-fill',
        bulletElement: 'li',
      },
      on: {
        slideChange: debounce(function () {
          const newIndex = this.activeIndex;
          playMobileVideoOnSlide(newIndex);
        }, 200)
      }
    });

    const mobileVideoContainers = mobileContainer.find('.swiper-slide .app-features__item-video-background-mobile');
    let mobileVideoElements = [];
    let mobileCurrentVideoIndex = -1;
    function updateMobileButtonState(index, isPlaying) {
      const playBtn = $(`#mobile-play-button-${index}`);
      const pauseBtn = $(`#mobile-pause-button-${index}`);
      if (playBtn.length && pauseBtn.length) {
        if (isPlaying) {
          playBtn.hide();
          pauseBtn.show();
        } else {
          playBtn.show();
          pauseBtn.hide();
        }
      }
    }

    function playMobileVideoOnSlide(index) {
      if (mobileCurrentVideoIndex !== -1 && mobileCurrentVideoIndex !== index) {
        pauseMobileVideo(mobileCurrentVideoIndex);
      }
      const video = mobileVideoElements[index];
      if (!video) return;
      if (video.ended) {
        video.currentTime = 0;
      }

      updateMobileButtonState(index, true);
      video.play().catch(() => {});
      mobileCurrentVideoIndex = index;
      $(video).off('ended').on('ended', function () {
        updateMobileButtonState(index, false);
      });
    }

    function pauseMobileVideo(index, { reset = false } = {}) {
      const video = mobileVideoElements[index];
      if (!video) return;
      video.pause();
      if (reset) {
        video.currentTime = 0;
      }
      updateMobileButtonState(index, false);
    }

    function setupMobileVideoListeners(video, index) {
      const playBtn = $(`#mobile-play-button-${index}`);
      const pauseBtn = $(`#mobile-pause-button-${index}`);

      if (playBtn.length) {
        playBtn.off('click').on('click', function () {
          playMobileVideoOnSlide(index);
        });
      }
      if (pauseBtn.length) {
        pauseBtn.off('click').on('click', function () {
          pauseMobileVideo(index);
        });
      }
      $(video).off('ended').on('ended', function () {
        updateMobileButtonState(index, false);
      });
    }

    mobileVideoContainers.each(function (index, container) {
      const video = $(container).find('video')[0];
      if (video) {
        mobileVideoElements.push(video);
        setupMobileVideoListeners(video, index);
      }
    });

    window.playVideo = function (index) {
      playMobileVideoOnSlide(index);
    };
    window.pauseVideo = function (index) {
      pauseMobileVideo(index);
    };
  }

  function debounce(func, delay) {
    let inDebounce;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => func.apply(context, args), delay);
    };
  }

  initDesktop();
  initMobile();
});


  } catch(e) { console.error(e); }
})();
})();
